import React from "react"

import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    Radio,
    RadioGroup,
    Button,
    FormLabel,
} from "@mui/material"

import { Controller } from "react-hook-form"

import { getError } from "./fields"

export interface ButtonRadioContent
{
    label: string;
    value: string;
}
interface MatesButtonRadioProps
{
    name: string;
    label: string;
    control: any;
    trigger: any;
    formState: any;
    disabled?: boolean;
    required?: boolean;
    onChange?: (data: string) => string;
    radios: ButtonRadioContent[];
    defaultValue?: string;
}
export class MatesButtonRadio extends React.Component<MatesButtonRadioProps, {}> {
    static defaultProps = {
        required: false,
    };

    render() {
        let error = getError(this.props.formState, this.props.name);
        return (
            <Controller
                name={this.props.name}
                control={this.props.control}
                defaultValue={this.props.defaultValue}
                render={({ field }) => (
                    <FormControl
                        component="fieldset"
                        variant="standard"
                        error={Boolean(error)}
                        required={this.props.required}
                        disabled={this.props.disabled || this.props.formState.isSubmitting}
                    >
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <FormLabel component="legend" sx={{mr: 3}}>{this.props.label}</FormLabel>
                            {/*<div style={{ flex: 1, marginRight: "20px" }}>{this.props.label}</div>*/}
                            <RadioGroup
                                {...field}
                                row
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    let value: string = event.target.value;
                                    const newValue = this.props.onChange?.(value) || value;
                                    field.onChange(newValue);
                                    this.props.trigger(this.props.name);
                                }}
                            >
                                {this.props.radios.map((content) => (
                                    <FormControlLabel
                                        key={content.value}
                                        value={content.value}
                                        control={<Radio sx={{ display: "none" }} />}
                                        label={
                                            <Button
                                                variant="contained"
                                                disabled={this.props.disabled || this.props.formState.isSubmitting}
                                                sx={{
                                                    backgroundColor: (theme) =>
                                                        field.value === content.value
                                                            ? "secondary.main"
                                                            : "white",
                                                    color: (theme) =>
                                                        field.value === content.value
                                                            ? "white"
                                                            : "secondary.main",
                                                }}
                                                onClick={(event: any) => {
                                                    let value: string = content.value;
                                                    const newValue = this.props.onChange?.(value) || value;
                                                    field.onChange(newValue);
                                                    this.props.trigger(this.props.name);
                                                }}
                                            >
                                                {content.label}
                                            </Button>

                                        }
                                    />
                                ))}
                            </RadioGroup>
                        </div>
                        <FormHelperText>{error?.message}</FormHelperText>
                    </FormControl>
                )}
            />
        );
    }
}
